const cookieName = () => {
    return "maskSelectorTestCookie"
}

export const setCookie = (value, days) => {

    let expires = "";

    if (days > 0) {
        let date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    document.cookie = encodeURIComponent(cookieName())+"="+
        encodeURIComponent(value)+expires+"; path=/";
}

export const getCookie = () => {
    return getCookies()[cookieName()];
}

const getCookies = () => {

    let c = document.cookie;
    let v = 0;
    let cookies = {};

    if (document.cookie.match(/^\s*\$Version=(?:"1"|1);\s*(.*)/)) {
        c = RegExp.$1;
        v = 1;
    }

    if (v === 0) {
        c.split(/[,;]/).map(function(cookie) {
            let parts = cookie.split(/=/, 2);
            let name = decodeURIComponent(parts[0].trimStart());

            cookies[name] = parts.length > 1 ? decodeURIComponent(parts[1].trimEnd()) : null;
        });
    } else {
        c.match(/(?:^|\s+)([!#$%&'*+\-.0-9A-Z^`a-z|~]+)=([!#$%&'*+\-.0-9A-Z^`a-z|~]*|"(?:[\x20-\x7E\x80\xFF]|\\[\x20-\x7F])*")(?=\s*[,;]|$)/g).map(function($0, $1) {
            let name = $0;

            let value = $1.charAt(0) === '"'
                    ? $1.substr(1, -1).replace(/\\(.)/g, "$1")
                    : $1;

            cookies[name] = value;
        });
    }

    return cookies;
}